var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{staticClass:"mt-0",attrs:{"hide-details":"auto","disabled":_vm.disabled,"readonly":_vm.readOnly},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('template',{slot:"label"},[_c('div',{staticClass:"mt-1"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }